import { useContext, useEffect } from "react";
import { GlobalContext } from "../../../context/GlobalContext";
import { useGetTree } from "../../../hooks/useGetTree";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { showScrollBtn } from "../../../utils/functions";
import Breadcumbs from "../../atoms/breadcumbs/Breadcumbs";
import SectionList from "../../molecules/sections-list/SectionList";
import TreeCategories from "../../molecules/tree-categories/TreeCategories";
import VideosAbout from "../../molecules/videos-about/VideosAbout";
import "./InternalSubcategoryTemplate.scss";

const InternalSubcategoryTemplate = () => {
  const { window } = useBrowserMode();
  const { selectedCategory, selectedSubCategory } = useGetTree();
  const { selectedTab } = useContext(GlobalContext);

  useEffect(() => {
    if (selectedSubCategory || selectedCategory) {
      selectedTab.set(
        selectedSubCategory.userType ?? selectedCategory.userType ?? "personas"
      );
    }
  }, []);

  useEffect(() => {
    const scrollBtn = document.getElementById("btnScrollTop")!;
    window.addEventListener("scroll", () => showScrollBtn(scrollBtn));

    return () => {
      window.removeEventListener("scroll", () => showScrollBtn(scrollBtn));
    };
  }, []);

  return (
    <div className="o-internal-subcategory-template">
      <div className="tree-and-section">
        <TreeCategories hideMobile />

        <div className="section-container">
          <Breadcumbs articleName="" selectedSubcategory={selectedCategory} />
          <SectionList
            category={selectedCategory}
            selectedSubcategory={selectedSubCategory}
          />
          <VideosAbout />
        </div>
      </div>
    </div>
  );
};

export default InternalSubcategoryTemplate;
